import React from "react";
import { useState, useEffect } from "react";
import PreDraftAttach from "../../Draft/Draft_Assess_Box/Draft_Q_list/PreDraftAttach";
import DraftPublishPreRead from "../../Draft/Draft_Assess_Box/DraftPreReadPublish/DraftPublishPreRead";
// all css comes from ...Draft_Q_list_PreRead.css
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../../axios";
import { Form } from "react-bootstrap";

export default function ScheduleEdit_PreRead() {
  const [publish, setPublish] = useState();
  const navigate = useNavigate();
  //Added this state by kuldeep
  const { state } = useLocation();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  // const Teacher_Json = "62d98b5e0cb0b264330e6d0e";
  const [updatePreread, setUpdatePreread] = useState({
    description: "",
    updateTittle: "",
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    attach: [],
  });
  const {
    description,
    attach,
    updateTittle,
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
  } = updatePreread;

  const [prescheduleData, setpreScheduleData] = useState({
    schedulePreRead: [],
  });
  const { schedulePreRead } = prescheduleData;

  useEffect(() => {
    const getSchedulePreRead = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/preRead/getById/${state.schedulePre_id}`
        );
        res &&
          setpreScheduleData({
            schedulePreRead: res.data.data,
          });

        setUpdatePreread({
          ...updatePreread,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          attach: res?.data.data.attachments,
          updateDeadline: res?.data.data.deadline,
          updateScheduleDate: res?.data.data.schedule_date,
          updateScheduleTime: res?.data.data.schedule_time,
        });
      } catch (error) { }
    };
    getSchedulePreRead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let createPreRead = {
    standard_id: schedulePreRead?.standard_id?.id,
    subject_id: schedulePreRead?.subject_id?.id,
    section_id: schedulePreRead?.section_id?.id,
    book_id: schedulePreRead?.book_id?.id,
    chapter_id: schedulePreRead?.chapter_id?.id,
    type: schedulePreRead?.type?.id,
    teacher_id: Teacher_Json,
    status: "draft",
    description: description,
    name: updateTittle,
    attachments: attach,
    deadline: updateDeadline,
  };

  // const handleClick = async () => {
  //   if (attach) {
  //     const formData = new FormData();
  //     formData.append("name", attach.name);
  //     formData.append("uploadPreReadAttachment", attach);
  //     try {
  //       const res = await axios.post(
  //         `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,

  //         formData
  //       );
  //       createPreRead.attachments = res.data.data;
  //     } catch (error) {}
  //   }
  // };

  const myFileInput = document.getElementById("attachFile");
  myFileInput?.addEventListener("change", (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("uploadPreReadAttachment", file);
    axios
      .post(
        `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,
        formData
      )
      .then((response) => {
        createPreRead.attachments = response.data.data;
        setUpdatePreread({
          ...updatePreread,
          attach: [response.data.data],
        });
        // setUserAttach([response.data.data]);
        // setAttach([response.data.data]);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  });
  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/preRead/update/${schedulePreRead.id}`,
        createPreRead
      );
      console.log(res);
      navigate("/PublishedHomeworkPreRead");
    } catch (error) {
      console.log(error);
    }
  };
  const isDisableButton =
    updatePreread.updateTittle === "" || updatePreread.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }

  return schedulePreRead ? (
    <>
      <div className="d-flex align-items-center  ">
        <NavLink to={`/ScheduleQListPreRead`} className="link" state={{ schedulePre_id: state.schedulePre_id }}>
          <img src="/images/Back Arrow.svg" className="Pointer" alt="" />
        </NavLink>
        <Link to="/PublishedHomeworkPreRead" className="link">
          <span className="open_publish_path_pre">
            &nbsp; Scheduled /&nbsp;
          </span>
        </Link>
        <Link to={`/ScheduleQListPreRead`} className="link" state={{ schedulePre_id: state.schedulePre_id }}>
          <span className="open_publish_path_pre">
            {schedulePreRead?.name} /&nbsp;
          </span>
        </Link>
        <span className="open_publish_path1_pre">
          Edit {schedulePreRead?.name}
        </span>
      </div>

      <div class="Draft-text">
        <input
          type="text"
          value={updateTittle}
          placeholder="Enter title"
          class="txt_draftName mt-3 form-control"
          id="txt-i-first"
          onChange={(e) =>
            setUpdatePreread({
              ...updatePreread,
              updateTittle: e.target.value,
            })
          }
        />
        {errors.updateTittle && (
          <span className="error">{errors.updateTittle}</span>
        )}
        <Form.Control
          as="textarea"
          placeholder="Enter Description"
          value={description}
          rows={4}
          className="px-3 py-2 mt-4 txt_draftdesc"
          onChange={(e) =>
            setUpdatePreread({
              ...updatePreread,
              description: e.target.value,
            })
          }
        />
        {errors.description && (
          <span className="error">{errors.description}</span>
        )}
      </div>
      <div className="AttachIcon_preRead_draft mt-3 me-3 gap-3 d-flex align-items-center justify-content-between ">
        <div>
          <input
            id="attachFile"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            style={{ display: "none" }}
            onChange={(e) =>
              setUpdatePreread({
                ...updatePreread,
                attach: e.target.files[0],
              })
            }
          />
          <label
            className="d-flex align-items-center gap-1 "
            htmlFor="attachFile"
          >
            <div className=" px-3 py-2 d-flex align-items-center justify-content-center prered_attach box">
              <img src="/images/Attach.svg" alt="" />
              <span className="activity_attach">&nbsp;Attach</span>
            </div>
          </label>
        </div>
      </div>
      <div className=" editSchedule_pdf_container_prepread d-flex">
        {/* pdf css comes from pdf file.css  */}
        {attach && attach.length !== 0 && (
          <PreDraftAttach
            setAttach={setUpdatePreread}
            updatePreread={updatePreread}
            attachData={schedulePreRead}
            attach={attach}
          />
        )}
      </div>

      <div class="me-4 btn_draft_pre mt-2 ">
        <button
          className="btn px-3 m-1 py-2 pre_QDraft_button"
          onClick={() => {
            helper();
          }}
          disabled={isDisableButton}
        >
          Save as Draft
        </button>

        <button
          className="btn m-1 py-2 prer_Qnext_button"
          onClick={(e) => setPublish(true)}
          disabled={isDisableButton}
        >
          Publish
        </button>
      </div>
      {publish && (
        <DraftPublishPreRead
          setPublish={setPublish}
          newPreRead={schedulePreRead}
          updatePreread={updatePreread}
        />
      )}
    </>
  ) : (
    <></>
  );
}
